const $body = $('html, body');
const $wrapper = $('.product-catalog-group');

$wrapper.on('click', '.sort-pagination__filter, .filter-close', () => $body.toggleClass('show-sidebar'));
$wrapper.on('click', '#filter-button, .apply-filters, .close-button', () => $body.removeClass('show-sidebar'));
$(window).on('resize', ({currentTarget: element}) => $(element).width() > 1024 && $body.removeClass('show-sidebar'));
